module.exports = __webpack_public_path__ + "static/luacheia-video-pt-6911afd8bfff5da0a39f7922d574efc2.mp4";